
export interface SharePage {
  title: string;
  image: string;
}
